const unavailable = (redirect) => {
  if (redirect) {
    window.location.href = '/unavailable';
  }
};

export default unavailable;
